/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ig-drop-down-trigger{display:block}.div-trigger{padding:1rem;text-align:center}.div-trigger mat-icon{color:#3b6dac}.div-text-trigger{width:100%;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.div-text-trigger .text{font-size:14px!important;font-weight:400!important;text-transform:uppercase}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/trigger/drop.down.trigger.component.scss.ngstyle.js.pre-build-optimizer.js